// Thrown by every parser in src/shared and src/worker/hooks when an input cannot be interpreted.
// `field` names the offending webhook key / sheet column when the caller knows it.
export class ParseError extends Error {
  constructor(
    message: string,
    public readonly field?: string,
  ) {
    super(message)
    this.name = 'ParseError'
  }
}
